import { NgModule } from '@angular/core';
import { UserService } from './services/user.service';
import { TicketService } from './services/ticket.service';
import { ServiceCatalogService } from './services/service-catalog.service';
import { RoleService } from './services/role.service';
import { ProjectService } from './services/project.service';
import { InventoryService } from './services/inventory.service';
import { GdprService } from './services/gdpr.service';
import { AccountingSageService } from './services/accounting-sage.service';
import { CompanyService } from './services/company.service';
import { AuthorizationService } from './services/authorization.service';
import { BusinessProjectService } from './services/business-project.service';
import { CellService } from './services/cell.service';
import { CustomerIdentityService } from './services/customer-identity.service';
import { InventoryUtils } from './services/inventory.utils';
import { InventorySchemaService } from './services/inventory-schema.service';
import { SlaPeriodService } from './services/sla-period.service';
import { AppService } from './services/app.service';
import { TribeService } from './services/tribe.service';
import { ReportService } from './services/report.service';
import { AuditService } from './services/audit.service';
import { AssignmentGroupConfigService } from './services/assignment-group-config.service';
import { FactoryService } from './services/factory.service';

@NgModule({
    imports: [],
    exports: [],
    declarations: [],
    providers: [
        CompanyService,
        CustomerIdentityService,
        CellService,
        BusinessProjectService,
        AuthorizationService,
        UserService,
        TicketService,
        ServiceCatalogService,
        RoleService,
        SlaPeriodService,
        ProjectService,
        InventoryService,
        GdprService,
        AccountingSageService,
        InventoryUtils,
        InventorySchemaService,
        AppService,
        TribeService,
        ReportService,
        AuditService,
        AssignmentGroupConfigService,
        FactoryService
    ],
})
export class DataModule { }
